import {
  CopyrightOutlined,
  FacebookFilled,
  InstagramFilled,
  LinkedinFilled,
  PhoneOutlined,
  QuestionCircleOutlined,
  TeamOutlined,
} from "@ant-design/icons";
import { faMoon, faSun } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Col, Row, Typography } from "antd";
import colors from "constants/colors";
import { useSetTheme } from "contexts/theme-context";
import { Link } from "react-router-dom";
import useViewport from "../../components/UseViewport/UseViewport";

import HallOfFame from "./HallOfFame/HallOfFame";

const { Title, Paragraph } = Typography;

export const Footer = () => {
  const setTheme = useSetTheme();
  const { width } = useViewport();
  const breakpoint = 900;

  return (
    <>
      <Row style={{ backgroundColor: colors.darkGray, zIndex: 2 }} className="footer">
        <Row
          gutter={{
            xs: 8,
            sm: 16,
            md: 24,
            lg: 32,
          }}
          style={{ width: "100%", paddingLeft: "5%", paddingRight: "2%", paddingTop: "5%" }}
        >
          <Col span={width < breakpoint ? 24 : 15}>
            {/* TODO fix styling */}
            <Title style={{ color: "white", fontSize: "1.5em" }}>Bindeleddet NTNU</Title>
            <Paragraph style={{ color: "white", paddingTop: "1%" }}>
              Studentorganisasjonen Bindeleddet NTNU sikrer kontakt mellom studenter ved Industriell økonomi og
              teknologiledelse og næringslivet. Organisasjonen ble opprettet og er drevet av studenter fra samme
              studieprogram.
            </Paragraph>
          </Col>
          <Col span={width < breakpoint ? 24 : 9} style={width < breakpoint ? {} : { textAlign: "right" }}>
            <Paragraph>
              <a style={{ color: "lightgrey" }} href="https://www.facebook.com/bindeleddet.ntnu/?fref=ts">
                <FacebookFilled style={{ fontSize: "2.2em" }} />
              </a>
              <a style={{ color: "lightgrey" }} href="https://www.instagram.com/bindeleddet/">
                <InstagramFilled style={{ fontSize: "2.2em", paddingLeft: "5%" }} />
              </a>
              <a style={{ color: "lightgrey" }} href="https://www.linkedin.com/company/bindeleddet-ntnu">
                <LinkedinFilled style={{ fontSize: "2.2em", paddingLeft: "5%" }} />
              </a>
            </Paragraph>
          </Col>
        </Row>

        <Row
          gutter={{
            xs: 8,
            sm: 16,
            md: 24,
            lg: 32,
          }}
          style={{ width: "70%", paddingLeft: "5%", paddingRight: "5%", paddingTop: "3%", paddingBottom: "3%" }}
        >
          <Col span={width < breakpoint ? 24 : 8}>
            <Paragraph>
              <Link to="/contact-us/" style={{ textDecoration: "none", color: "white" }}>
                <QuestionCircleOutlined style={{ paddingRight: "3%", fontSize: "1.1em" }} /> Ofte stilte spørsmål
              </Link>
            </Paragraph>
          </Col>
          <Col span={width < breakpoint ? 24 : 8}>
            <Paragraph>
              <Link to="/contact-us/" style={{ textDecoration: "none", color: "white" }}>
                <PhoneOutlined style={{ paddingRight: "3%", fontSize: "1.1em" }} /> Kontaktinformasjon
              </Link>
            </Paragraph>
          </Col>
          <Col span={width < breakpoint ? 24 : 8}>
            <Paragraph>
              <Link to="/about-us/members/" style={{ textDecoration: "none", color: "white" }}>
                <TeamOutlined style={{ paddingRight: "3%", fontSize: "1.1em" }} /> Våre medlemmer
              </Link>
            </Paragraph>
          </Col>
        </Row>

        <Row
          gutter={{
            xs: 8,
            sm: 16,
            md: 24,
            lg: 32,
          }}
          style={{ width: "100%", paddingLeft: "5%", paddingRight: "2%" }}
        >
          <Col span={width < breakpoint ? 24 : 10}>
            <Link to="/privacy-policy/" style={{ textDecoration: "none", color: "grey" }}>
              {"Personvern | "}
            </Link>
            <Link to="/user-terms/" style={{ textDecoration: "none", color: "grey" }}>
              {"Brukevilkår | "}
            </Link>
            <HallOfFame />
          </Col>
          <Col
            span={width < breakpoint ? 24 : 4}
            style={{
              justifyContent: width < breakpoint ? "left" : "center",
              display: "flex",
              paddingBottom: "10px",
              position: "relative",
              bottom: width < breakpoint ? "-2px" : "3px",
            }}
          >
            <Button type="link" style={{ color: "grey", padding: 0 }} onClick={() => setTheme("light", true)}>
              <FontAwesomeIcon icon={faSun} style={{ color: "grey", marginRight: "5px" }} /> Lys modus |{" "}
            </Button>
            <Button type="link" style={{ color: "grey", padding: 0 }} onClick={() => setTheme("dark", true)}>
              Mørk modus <FontAwesomeIcon icon={faMoon} style={{ color: "grey", marginLeft: "5px" }} />
            </Button>
          </Col>
          <Col span={width < breakpoint ? 24 : 10} style={width < breakpoint ? {} : { textAlign: "right" }}>
            <Paragraph style={{ color: "grey", paddingRight: "0.37em" }}>
              {new Date().getFullYear()} <CopyrightOutlined /> Bindeleddet NTNU. All rights reserved.
            </Paragraph>
          </Col>
        </Row>
      </Row>
    </>
  );
};
